import { useEffect, useState } from "react";
import { api } from "./api";

let _cache = null;
let _listeners = [];

/**
 * useSiteSettings — fetches editable settings from /api/settings.
 * Cached globally so all pages share the same fetch. Mergeable with the
 * static SITE constants in lib/site.js (used as fallback).
 */
export function useSiteSettings() {
  const [settings, setSettings] = useState(_cache);

  useEffect(() => {
    _listeners.push(setSettings);
    if (!_cache) {
      api.get("/settings").then(({ data }) => {
        _cache = data;
        _listeners.forEach((fn) => fn(data));
      }).catch(() => {
        // No settings yet — UI uses defaults.
      });
    }
    return () => { _listeners = _listeners.filter((fn) => fn !== setSettings); };
  }, []);

  const refresh = async () => {
    const { data } = await api.get("/settings");
    _cache = data;
    _listeners.forEach((fn) => fn(data));
  };

  return { settings, refresh };
}

export const invalidateSettings = () => { _cache = null; };
